package com.essntl.features.proposal.ui.addeditproposal.components

import androidx.compose.foundation.background
import androidx.compose.foundation.layout.*
import androidx.compose.foundation.shape.RoundedCornerShape
import androidx.compose.material3.Text
import androidx.compose.runtime.Composable
import androidx.compose.ui.Alignment
import androidx.compose.ui.Modifier
import androidx.compose.ui.draw.clip
import androidx.compose.ui.graphics.Color
import com.essntl.features.proposal.ui.addeditproposal.AddEditProposalNavigation
import com.essntl.features.proposal.ui.addeditproposal.AddEditProposalState
import com.essntl.uikit.components.iconbutton.outline.EsSmallOutlineIconButton
import com.essntl.uikit.components.icons.EsIcons
import com.essntl.uikit.components.utils.EsConstants
import com.essntl.uikit.components.utils.spacing
import com.essntl.uikit.theme.Accent200

@Composable
fun ConfirmedProposalBanner(
    state: AddEditProposalState,
    onNavigation: (AddEditProposalNavigation) -> Unit,
) =
    Row(
        horizontalArrangement = Arrangement.Center,
        verticalAlignment = Alignment.CenterVertically,
        modifier =
        Modifier
            .fillMaxWidth()
            .clip(RoundedCornerShape(EsConstants.SectionBorderRadius))
            .background(Accent200)
            .padding(
                vertical = EsConstants.SectionVerticalPadding,
                horizontal = EsConstants.SectionHorizontalPadding,
            ),
    ) {
        Text(
            text = "Proposal confirmed, it cannot be edited anymore. Edit the itinerary instead",
            color = Color.Black,
        )

        Spacer(modifier = Modifier.width(.5.spacing))

        EsSmallOutlineIconButton(
            iconRes = EsIcons.Itinerary,
            modifier = Modifier.align(Alignment.CenterVertically),
            onClick = {
                state.proposal.value.itineraryId?.let {
                    onNavigation(
                        AddEditProposalNavigation.NavigateToItinerary(itineraryId = it),
                    )
                }
            },
        )
    }